




const Normalize = function(vec){
  let len = Math.sqrt(vec.x*vec.x + vec.y*vec.y);
  let x = vec.x / len;
  let y = vec.y / len;
  return {x:x, y:y}
}

// vecオブジェクト
// 回転は度数法で送る
const Rotate = function( vec, rotate ){
  // ラジアンに直す
  let rad = (rotate * Math.PI) / 180;
  let x = vec.x * Math.cos(rad) - vec.y * Math.sin(rad);
  let y = vec.x * Math.sin(rad) + vec.y * Math.cos(rad);
  return {x:x, y:y}
}

const Dot = function( vec1, vec2 ){
  return vec1.x * vec2.x + vec1.y * vec2.y;
  // x1*x2 + y1*y2
}

export {Rotate, Dot, Normalize}